var FormValidator = function (form, rules, onSuccess, onError) {
    $(form).formValidation({
        framework: 'bootstrap',
        excluded: [':disabled', ':hidden', ':not(:visible)'],
        icon: {
            valid: 'glyphicon glyphicon-ok',
            invalid: 'glyphicon glyphicon-remove',
            validating: 'glyphicon glyphicon-refresh'
        },
        live: 'enabled',
        message: 'This value is not valid',
        trigger: null,
        fields: rules
    }).on('success.form.fv', function (e) {
        e.preventDefault();

        onSuccess(form, e);
    }).on('error.form.fv', function (e) {
        e.preventDefault();
        
        onError(form, e);
    });
};

module.exports = FormValidator;
